import React from 'react'
import { useNavigate } from 'react-router-dom'

import { AddIncomeCard } from '@frame/ui-components/add-income-card'
import { ExitPromptType } from '@frame/ui-components/exit-prompt'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'

import { InternalEventType } from '@frame/lib/api/events/types'
import { TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { useEventHandler } from '@frame/lib/hooks/useEventHandler'
import { useHeaderTitle } from '@frame/lib/hooks/useHeaderTitle'
import { useShowExitPrompt } from '@frame/lib/hooks/useShowExitPrompt'
import { useStrategies } from '@frame/lib/hooks/useStrategies'
import { useStore } from '@frame/lib/stores/useStore'
import { IncomeType } from '@frame/lib/types'
import { routes } from '@frame/routes'
import { DataAttribute } from '@frame/types'

export function SelectIncomeType() {
  const navigate = useNavigate()
  const { handleEvent } = useEventHandler()
  const { bilEnabledStrategiesNoBank } = useStrategies()
  const showExitPrompt = useShowExitPrompt()
  const title = useHeaderTitle()
  const { skipApplicantStatedInfo } = useStore(({ session }) => ({
    skipApplicantStatedInfo: session?.configuration.skip_applicant_stated_info ?? false,
  }))

  return (
    <>
      <WidgetHeaderWithNavigation
        title={title}
        showExitPrompt={showExitPrompt}
        exitPromptType={ExitPromptType.EMPLOYER}
      />
      <Body data-cy={DataAttribute.POS_SCREEN_SELECT_INCOME_TYPE} paddingTopOverride={0} className="space-y-4 p-5">
        {bilEnabledStrategiesNoBank.map((strategy) => {
          switch (strategy) {
            case TrueworkJsStrategy.CREDENTIALS:
              return (
                <AddIncomeCard
                  key={strategy}
                  incomeType={IncomeType.EMPLOYED}
                  onClick={() => {
                    if (skipApplicantStatedInfo) {
                      navigate(routes.companySearch)
                    } else {
                      navigate(routes.statedInformation)
                    }
                    handleEvent(InternalEventType.INCOME_TYPE_SELECTED)
                  }}
                />
              )
            case TrueworkJsStrategy.DOCUMENTS:
              return (
                <AddIncomeCard
                  key={strategy}
                  incomeType={IncomeType.OTHER}
                  onClick={() => {
                    navigate(routes.documents)
                    handleEvent(InternalEventType.INCOME_TYPE_SELECTED)
                  }}
                />
              )
            default:
              return null
          }
        })}
      </Body>
    </>
  )
}
